var svg = {};
export {
  svg as __exports
};
//# sourceMappingURL=index216.js.map
